<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps({
    // eslint-disable-next-line
  error: Object as () => NuxtError,
})
console.log(props.error)
</script>

<template>
  <NuxtLayout>
    <main class="flex h-screen">
      <div
          v-if="error?.statusCode == 404"
          class="grow grid h-5/6 place-content-center px-4"
      >
        <div class="text-center">
          <h1 class="text-9xl font-black text-gray-200">
            404
          </h1>

          <p class="text-2xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Oops, page not found.
          </p>

          <p class="mt-4 text-gray-500">
            We are very sorry for the inconvenience. It looks like you are
            trying to access a page that either has been deleted or never
            existed.
          </p>

          <a
              href="/"
              class="mt-6 inline-block rounded bg-indigo-600 px-5 py-3 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring"
          >
            Go Back Home
          </a>
        </div>
      </div>
      <div
          v-else-if="error?.statusCode == 401 || error?.statusCode == 403"
          class="grow grid h-5/6 place-content-center px-4"
      >
        <div class="text-center">
          <h1 class="text-9xl font-black text-gray-200">
            {{ error.statusCode }}
          </h1>

          <p class="text-2xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Oops, you've found something that is currently published.
          </p>

          <p class="mt-4 text-gray-500">
            We are very sorry for the inconvenience. It looks like you are
            trying to access a page that either has been deleted or never
            existed.
          </p>

          <a
              href="/"
              class="mt-6 inline-block rounded bg-indigo-600 px-5 py-3 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring"
          >
            Go Back Home
          </a>
        </div>
      </div>
      <div
          v-else
          class="grow grid h-5/6 place-content-center px-4"
      >
        <div class="text-center">
          <h1 class="text-9xl font-black text-gray-200">
            {{ error?.statusCode }}
          </h1>

          <p class="text-2xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Oops, something went wrong.
          </p>

          <p class="mt-4 text-gray-500">
            We are very sorry for the inconvenience. It looks like we are having
            some technical issues.
          </p>

          <a
              href="/"
              class="mt-6 inline-block rounded bg-indigo-600 px-5 py-3 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring"
          >
            Go Back Home
          </a>
        </div>
      </div>
    </main>
  </NuxtLayout>
</template>
